import { render, staticRenderFns } from "./commonContent.vue?vue&type=template&id=0f2eaed1&scoped=true"
import script from "./commonContent.vue?vue&type=script&lang=js"
export * from "./commonContent.vue?vue&type=script&lang=js"
import style0 from "./commonContent.vue?vue&type=style&index=0&id=0f2eaed1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2eaed1",
  null
  
)

export default component.exports